<template>
    <div class="home">
        <b-img src="images/bild_vilsa_t.jpg" fluid />
        <span v-html="$t('presentation.team')" />
        <b-card-group deck>
            <b-card title="Peter Thiele"
                img-src="images/team/Thiele.jpg"
                style="max-width: 300px;"
                img-top
                >
                <p class="card-text">
                    Einkaufsleitung VILSA<br/><br/>
                    <a href="mailto: peter.thiele@vilsa.de">peter.thiele@vilsa.de</a><br/>
                    Tel. +49 4252 392 500
                </p>
            </b-card>
            <b-card title="André Grotstabel"
                img-src="images/team/Grotstabel.jpg"
                style="max-width: 300px;"
                img-top
                >
                <p class="card-text">
                    Koordination Materialeinkauf und Dienstleistungen<br/><br/>
                    <a href="mailto: andre.grotstabel@ebnerstolz.de">andre.grotstabel@ebnerstolz.de</a><br/>
                    Tel. +49 173 250 1031
                </p>
            </b-card>
        </b-card-group>
        <br/>
        <br/>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'team',
        data() {
            return {};
        },
        computed: {
            ...mapGetters({
                auth: 'auth/auth'
            })
        }
    }
</script>